import { createAction } from '@reduxjs/toolkit';
import { clearUserData } from '../slices/userSlice';
import { fetchDesignations } from './designationActions';
import { store } from '../store';

// This action forcefully clears all user data (including designations) and fetches fresh designations
export const forceRefreshDesignations = createAction('users/forceRefreshDesignations', () => {
  console.log('Force refreshing designations - clearing all cache and fetching fresh data');
  
  // Clear all user data from Redux and localStorage
  store.dispatch(clearUserData());
  
  // Then fetch fresh designations
  store.dispatch(fetchDesignations());
  
  return { payload: {} };
});
